/**
 * Принудительный филиал — только по явной настройке окружения.
 *
 * Раньше вне прода филиал прибивался к тестовому (53), потому что «ближайший»
 * по дефолтным координатам получался случайным. Захардкоженного значения
 * больше нет: без VITE_BRANCH_ID филиал везде вычисляется по адресу или
 * геолокации, как в проде. Если для локальной отладки нужен конкретный —
 * VITE_BRANCH_ID=<id> в .env.local или в настройках проекта на Vercel.
 *
 * 0 — подмены нет, работаем как обычно.
 */
const configured = Number(import.meta.env.VITE_BRANCH_ID);

export const FORCED_BRANCH_ID = configured > 0 ? configured : 0;
